import React, { useState } from "react";
import { Button, SecondaryButton } from "components/Form";
import { DialogActions } from "components/MaterialDialog";
import { useSubmitHandler } from "components/Form/FormikControls";

export interface BulkReportFormProps {
  reportSlug: string;
  onClose: () => void;
}

interface ModalActionsProps {
  allowInitialSubmit: boolean;
  onClose: () => void;
}

export function ModalActions(props: ModalActionsProps): React.JSX.Element {
  const { allowInitialSubmit = false, onClose } = props;

  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  useSubmitHandler(allowInitialSubmit, setIsSubmitEnabled);

  return (
    <DialogActions>
      <SecondaryButton onClick={onClose}>Back</SecondaryButton>
      <Button type="submit" data-tour="submit" disabled={!isSubmitEnabled}>
        Generate Reports
      </Button>
    </DialogActions>
  );
}
